import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetSocialAppId({
  platform,
}: {
  platform: 'google' | 'facebook'
}) {
  const fetchData = async () => {
    const response = await httpClient.get(`auth/social/app-id`, {
      params: {
        platform,
      },
    })

    return response.data
  }

  return useQuery({
    queryKey: ['social-app-id', platform],
    queryFn: fetchData,
    staleTime: Infinity,
  })
}
